<template lang="pug">
.fam-slides
  empty-state(v-if="famUsers.length < 1" copy="还未添加家庭成员")
  .swiper-container(ref="swiper")
    .swiper-wrapper
      .swiper-slide(v-for="(u, i) in famUsers" :key="i")
        fam-zoom-card(:idx="i+1" :total="famUsers.length" :progress="progress" :transitioning="transitioning")
          fam-card-view
            avatar-adult(v-if="u.userType === 0" :adult="u")
            avatar-child(v-if="u.userType === 2" :child="u")
      //.swiper-slide(v-if="getAdultAdded.length>0")
        fam-zoom-card(:idx="1" :total="3" :progress="progress" :transitioning="transitioning")
          fam-card-view
            avatar-adult
      //.swiper-slide(v-if="getChildrenAdded.length>0")
        fam-zoom-card(:idx="2" :total="3" :progress="progress" :transitioning="transitioning")
          fam-card-view
            avatar-child(:idx="0")
      //.swiper-slide(v-if="getChildrenAdded.length>1")
        fam-zoom-card(:idx="3" :total="3" :progress="progress" :transitioning="transitioning")
          fam-card-view
            avatar-child(:idx="1")
    .swiper-pagination(ref="pagination")
  
</template>
<script>
import Swiper from 'swiper'
import { mapGetters, mapMutations, mapState } from 'vuex'
import FamZoomCard from '@/components/me/FamZoomCard'
import FamCardView from '@/components/me/FamCardView'
import AvatarAdult from '@/components/me/AvatarAdult2'
import AvatarChild from '@/components/me/AvatarChild2'
import EmptyState from '@/components/wedgits/EmptyState'

export default {
  name: 'FamSlides',
  components: {
    EmptyState,
    AvatarChild,
    AvatarAdult,
    FamCardView,
    FamZoomCard,
  },
  props: {
    activeCard: {
      default: -1,
    },
  },
  data() {
    return {
      progress: 0,
      transitioning: false,
    }
  },
  computed: {
    ...mapState('app', ['user']),

    famUsers() {
      return this.user.famUsers.filter((u) => {
        return u.id !== this.user.id
      })
    },
  },
  watch: {
    famUsers: {
      deep: true,
      handler(val) {
        if (this.swiper) this.swiper.update()
      },
    },
  },
  methods: {
    ...mapMutations('app', ['setRouterBack']),
    onCardClick(i) {
      if (this.activeCard === i) {
        console.log(999)
        this.$router.replace('/introduction/intro')
        this.setRouterBack('/')
      } else {
        this.setRouterBack('/introduction/intro')
        this.$router.replace('/introduction/intro/' + i)
      }
    },
  },
  mounted() {
    this.swiper = new Swiper(this.$refs.swiper, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: true,
      pagination: {
        el: this.$refs.pagination,
      },
      on: {
        progress: (swiper, p) => {
          //console.log(p)
          this.progress = p
        },
        transitionStart: () => {
          // if (this.swiper)
          //   console.log('trans', this.swiper.wrapperEl.style.transitionDuration)
          this.transitioning = true
        },
        transitionEnd: () => {
          console.log('trans end')
          this.transitioning = false
        },
      },
    })
  },
}
</script>

<style scoped lang="sass">
@import "../../styles/common"
.fam-slides
  width: 100%
  .swiper-container
    width: 100%
    overflow: visible
    .swiper-slide
      //background: #42b983
      //background: #ffffff
      width: pxToRem(582)
      height: pxToRem(620)
  .swiper-pagination
    position: relative
    top: pxToRem(0)
</style>
